module.exports = __webpack_public_path__ + "static/media/loop_checklist.97b46bc5.svg";